<!-- dialog view -->
@if(modal()){
  <div class="p-16 d-flex align-items-center justify-content-between" 
  cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  ngxResizable
  [ngxResizableDisabled]="!resizable()"
  [cdkDragDisabled]="!draggable()"
  [ngxResizableTargetElement]="'.mat-mdc-dialog-surface'"
  [ngxResizableEventClass]="'modal-file-resizing'"
  >
    <h2 mat-dialog-title>{{ dataModule?.name }}</h2>
      <div class="close-button close">
        <button mat-icon-button (click)="close()">
          <i-tabler name="xbox-x"></i-tabler>
        </button>
      </div>
  </div>
  <mat-dialog-content class="mat-typography p-0">

    <app-draw [imageBase64]="getSafeUrlAsString()"
      [isEditMode]="isEditMode"
      (canvasReady)="canvasReady($event)"
      (croppedData)="stopCropping($event)"
      (onClickSave)="saveCanvas($event)"></app-draw>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
      @if (!isEditMode) {
      <button mat-flat-button class="bg-primary text-white" (click)="sendFile()">
        <i-tabler name="photo-share"
          class="icon-20 mdi-format-vertical-align-center"
          style="vertical-align: middle"></i-tabler>
        {{ 'filemanager.editor.send' | translate }}
      </button>
      } @else {
      <button mat-flat-button class="bg-primary text-white" (click)="saveFile()">
        <i-tabler name="photo-save"
          class="icon-20 mdi-format-vertical-align-center"
          style="vertical-align: middle"></i-tabler>
        {{ 'filemanager.editor.save' | translate }}
      </button>
      }
    <!-- <button mat-flat-button class="bg-error text-white"
      (click)="close()">Close</button> -->
  </mat-dialog-actions>
}@else{
  @if (dataModule) {
    <div class="p-16 d-flex align-items-center justify-content-between"
    cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    ngxResizable
    [ngxResizableDisabled]="!resizable()"
    [cdkDragDisabled]="!draggable()"
    [ngxResizableTargetElement]="'.mat-mdc-dialog-surface'"
    [ngxResizableEventClass]="'modal-file-resizing'">
        <h3 class="dialog-title">{{ dataModule.name }}
          @if(dataModule.page){
            - {{ 'filemanager.file.page' | translate }}:{{dataModule.page}}
          }
        </h3>
        @if(showClose()){
          <div class="close-button close">
            <button mat-icon-button (click)="closeDirect()">
              <i-tabler name="xbox-x"></i-tabler>
            </button>
          </div>
        }
  </div>
  }
  <mat-dialog-content class="mat-typography p-0">
    <app-draw [imageBase64]="getSafeUrlAsString()"
      [isEditMode]="isEditMode"
      (canvasReady)="canvasReady($event)"
      (croppedData)="stopCropping($event)"
      (onClickSave)="saveCanvas($event)"></app-draw>
  </mat-dialog-content>
  <!-- @if(showClose() && modal()){
      <mat-dialog-actions align="end">
          <button mat-flat-button class="bg-error text-white"
          (click)="close()">Chiudi</button>
      </mat-dialog-actions>
    } -->
}